// extracted by mini-css-extract-plugin
export var Category = "style-module--Category--f3034";
export var Details = "style-module--Details--f22f0";
export var Links = "style-module--Links--7602a";
export var Project = "style-module--Project--6d27a";
export var ProjectImage = "style-module--ProjectImage--8eee9";
export var ProjectImageWrapper = "style-module--ProjectImageWrapper--668f6";
export var Tags = "style-module--Tags--d7936";
export var Title = "style-module--Title--8501a";